import { Badge, Box, HStack, Stack, StackProps, Text, TextProps, VStack } from '@chakra-ui/react'
import { UserAvatar, UserAvatarProps } from '@src/components/sco/Account/UserAvatar'
import { ScoUser } from '@src/graphql-types'
import { gql } from '@src/lib/gql'
import React from 'react'

export type UserChipProps = {
  children?: any
  userAvatarProps?: UserAvatarProps
  displayNameProps?: TextProps
  stackProps?: StackProps
  user: ScoUser
  show?: {
    email?: boolean
    title?: boolean
    productBadges?: boolean
  }
}

export const UserChip: React.FC<UserChipProps> & { fragments: any } = props => {
  const hasAdvisor = props.user.contentPermissions?.canAccessFGAdvisor
  const hasCommunity = props.user.contentPermissions?.canAccessFGMemberDirectory
  const isFree = props.user.subscriptions?.some(sub => !sub.isActive)
  const isAdmin = props.user.isAdmin

  return (
    <Stack align={'center'} direction={'row'} gap={'0.75em'} justify={'flex-start'} {...props.stackProps}>
      <UserAvatar
        avatarProps={{ boxShadow: 'xs', size: 'md' }}
        border={'none'}
        user={props.user}
        {...props.userAvatarProps}
      />
      <VStack align={'flex-start'} gap={1} justify={'center'} paddingY={1}>
        <HStack align={'center'} gap={4} justify={'center'}>
          <Text
            color={'fg'}
            fontFamily={'Poppins'}
            fontSize={'md'}
            fontWeight={'semibold'}
            lineHeight={1}
            whiteSpace={'nowrap'}
            {...props.displayNameProps}
          >
            {props.user.displayName}
          </Text>
          {props.show?.productBadges && (
            <>
              {isAdmin ? (
                <Badge>Admin</Badge>
              ) : hasAdvisor ? (
                <Badge colorPalette={'green'}>ADVISOR</Badge>
              ) : hasCommunity ? (
                <Badge colorPalette={'blue'}>COMMUNITY</Badge>
              ) : (
                <Badge>Free</Badge>
              )}
            </>
          )}
        </HStack>
        {props.show?.email && props.user.email && (
          <Box>
            <Text color={'fg'} fontSize={'sm'} lineHeight={1}>
              {props.user.email}
            </Text>
          </Box>
        )}
        {props.show?.title && props.user.title && (
          <Text color={'fg'} fontSize={'sm'} lineHeight={1}>
            {props.user.title}
          </Text>
        )}
        {props.children}
      </VStack>
    </Stack>
  )
}

UserChip.fragments = {
  ScoUser: () => gql`
    fragment _ on ScoUser {
      id
      userId
      fullName
      displayName
      pictureUrl
      lastActiveAt
      title
      company {
        id
        name
        url
        logoUrl
        elevatorPitch
        industryKeys
        industryKey
      }
      isAdmin
      subscriptions {
        id
        isActive
      }
      contentPermissions {
        id
        canAccessFGAdvisor
        canAccessFGMemberDirectory
      }
    }
  `,
}
